module.exports = __webpack_public_path__ + "img/Gestor2.ed55b89e.png";